import React from 'react';
interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
  size?: 'sm' | 'md';
}
export function Toggle({
  checked,
  onChange,
  label,
  disabled = false,
  size = 'md'
}: ToggleProps) {
  const sizeClasses = {
    sm: {
      switch: 'h-5 w-9',
      dot: 'h-4 w-4',
      translate: 'translate-x-[15px]',
      offset: 'left-0.5 top-0.5'
    },
    md: {
      switch: 'h-6 w-11',
      dot: 'h-5 w-5',
      translate: 'translate-x-[19px]',
      offset: 'left-0.5 top-0.5'
    }
  };
  const currentSize = sizeClasses[size];
  return <label className={`inline-flex items-center ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`} data-id="element-522">
      <div className="relative" data-id="element-523">
        <input type="checkbox" className="sr-only" checked={checked} onChange={e => !disabled && onChange(e.target.checked)} disabled={disabled} data-id="element-524" />
        <div className={`${currentSize.switch} rounded-full transition-colors duration-200 ease-in-out ${checked ? 'bg-primary-500' : 'bg-slate-200'}`} data-id="element-525"></div>
        <div className={`absolute ${currentSize.offset} bg-white rounded-full shadow transform transition-transform duration-200 ease-in-out ${currentSize.dot} ${checked ? currentSize.translate : 'translate-x-0'}`} data-id="element-526"></div>
      </div>
      {label && <span className="ml-3 text-sm font-medium text-slate-700" data-id="element-527">{label}</span>}
    </label>;
}